<template>
    <div class="activity-indicator-circle-trail">
        <div class="activity-indicator-circle-trail1 activity-indicator-child" />
        <div class="activity-indicator-circle-trail2 activity-indicator-child" />
        <div class="activity-indicator-circle-trail3 activity-indicator-child" />
        <div class="activity-indicator-circle-trail4 activity-indicator-child" />
        <div class="activity-indicator-circle-trail5 activity-indicator-child" />
        <div class="activity-indicator-circle-trail6 activity-indicator-child" />
        <div class="activity-indicator-circle-trail7 activity-indicator-child" />
        <div class="activity-indicator-circle-trail8 activity-indicator-child" />
        <div class="activity-indicator-circle-trail9 activity-indicator-child" />
        <div class="activity-indicator-circle-trail10 activity-indicator-child" />
        <div class="activity-indicator-circle-trail11 activity-indicator-child" />
        <div class="activity-indicator-circle-trail12 activity-indicator-child" />
    </div>
</template>